exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hoverable[data-v-4e186861]:hover {\n  background: #ebebeb;\n}\n.taller[data-v-4e186861] {\n  height: 8rem;\n  font-size: 85%;\n}", ""]);

// exports
